import { useState } from 'react';
import { navLinks } from '@/mocks/homeData';

export default function SiteNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/90 backdrop-blur-md">
      <div className="flex h-16 w-full items-center justify-between px-4 md:h-20 md:px-10">
        <h1 className="flex items-center">
          <a href="#top" className="flex cursor-pointer items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 md:h-10 md:w-10">
              <i className="ri-newspaper-line text-lg md:text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
                黑料网址
              </span>
              <span className="mt-1 text-[10px] tracking-[0.28em] text-foreground-500">
                DAILY · 第 018 期
              </span>
            </span>
          </a>
        </h1>

        <nav className="hidden items-center gap-8 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#join"
            className="hidden cursor-pointer whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            加入交流
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((value) => !value)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-md px-3 py-3 text-sm text-foreground-700 transition-colors hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#join"
              onClick={() => setOpen(false)}
              className="mt-1 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-3 py-3 text-center text-sm text-background-50"
            >
              加入交流
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}